export default __webpack_public_path__ + "static/MNSMMOONSHINECLUBTEE_600x600-72decf3722f6686d600bf5d26b87e751.png";